import { Status } from '@sift/resift/models/Status';
import memoizeLast from '@sift/resift/memoizeLast';

function combineStatuses(...statuses) {
  return statuses.reduce((combined, status) => combined.or(status), new Status());
}

export default memoizeLast(combineStatuses);
